import PropTypes from 'prop-types';
import Modal from '../Common/Modal';
import Button from '../Common/Button';

const RemoveProjectUserConfirmModal = ({
  isOpen,
  onClose,
  user,
  project,
  onConfirm,
  removing = false,
}) => {
  const displayName = user?.name || user?.userName || user?.email || 'this user';
  const projectName = project?.projectName || project?.name || 'this project';
  const role = user?.role || '';
  const isPending = user?.status === 'pending';

  return (
    <Modal
      isOpen={isOpen}
      onClose={removing ? () => {} : onClose}
      title="Remove from project"
      size="small"
      content={
        <div className="px-4 py-3 space-y-3">
          <p className="text-sm text-[#6B7C93] dark:text-[#8FA3B8]">
            Are you sure you want to remove{' '}
            <b className="text-[#0A2342] dark:text-white">{displayName}</b> from{' '}
            <b className="text-[#0A2342] dark:text-white">{projectName}</b>?
          </p>
          {(user?.email || role) && (
            <p className="text-xs text-[#6B7C93] dark:text-[#8FA3B8]">
              {[user?.email, role, isPending ? 'Pending invite' : null]
                .filter(Boolean)
                .join(' · ')}
            </p>
          )}
          <p className="text-xs text-[#6B7C93] dark:text-[#8FA3B8]">
            This will revoke their access to this project. This action cannot be undone from here.
          </p>
        </div>
      }
      actions={
        <div className="flex items-center gap-2">
          <Button variant="secondary" onClick={onClose} disabled={removing}>
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={onConfirm}
            disabled={removing}
            className="!bg-red-600 hover:!bg-red-700 focus:!ring-red-300 dark:!bg-red-600 dark:hover:!bg-red-700"
          >
            {removing ? 'Removing...' : 'Remove'}
          </Button>
        </div>
      }
    />
  );
};

RemoveProjectUserConfirmModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  user: PropTypes.object,
  project: PropTypes.object,
  onConfirm: PropTypes.func.isRequired,
  removing: PropTypes.bool,
};

RemoveProjectUserConfirmModal.defaultProps = {
  user: null,
  project: null,
  removing: false,
};

export default RemoveProjectUserConfirmModal;
